import { getContract, PublicClient } from 'viem'

import { REVERSE_RECORDS_ADDRESS } from '~/constants/addresses'

const reverseRecordsAbi = [
  {
    inputs: [{ internalType: 'contract ENS', name: '_ens', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'addresses', type: 'address[]' },
    ],
    name: 'getNames',
    outputs: [{ internalType: 'string[]', name: 'r', type: 'string[]' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const

export const getReadReverseRecordsContract = ({
  publicClient,
}: {
  publicClient: PublicClient
}) => {
  return getContract({
    address: REVERSE_RECORDS_ADDRESS,
    abi: reverseRecordsAbi,
    client: publicClient,
  })
}
